module.exports = __webpack_public_path__ + "static/5-3a88ec6d23a7aaff20412b6be3cb36d8.jpg";